import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { GlobalService } from '../services/global.service';
import { UserIdleService } from 'angular-user-idle';
import { AuthFacade } from '../ngrx/auth/auth.facade';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    private router: Router,
    private storage: StorageService,
    private route: ActivatedRoute,
    private global: GlobalService,
    private userIdle: UserIdleService,
    private authFacade: AuthFacade
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (next.queryParams.param) {
      this.authFacade.insertDataToDB(next.queryParams.param);
    }
    return this.processAuth(next.url[0].path);
  }

  processAuth(redirectUrl) {
    this.authFacade.getDataFromDB().then(
      data => {
        if (data.access_token !== '' && data.access_token !== undefined) {
          console.log('====================================');
          console.log('Valid Credentials');
          console.log('====================================');
        } else {
          console.log('====================================');
          console.log('Invalid Credentials', redirectUrl);
          console.log('====================================');
          this.router.navigate(['/login']);
        }
      }
    );
    return true;
  }
}
